export default "__VITE_ASSET__g56PSVz9__"